export default __webpack_public_path__ + "static/media/206.b96584e5.gif";